/**
 * DigitalConnectKpiService — Titan client for Digital Connect payoff KPI endpoints.
 */

import type { SubmissionSummary } from '@/types/payoffProcessing';
import BaseService from '../BaseService';

/** Response shape for GET `payoff/submissions/summary` on the Digital Connect service. */
export type PayoffSummary = SubmissionSummary;

export class DigitalConnectKpiService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  getPayoffSummary = (): Promise<SubmissionSummary> =>
    this.get<SubmissionSummary>({ path: 'payoff/submissions/summary' });
}

export default DigitalConnectKpiService;
